import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import { tokens } from '../theme';
import site, { usePageMeta } from '../content';

const Email = () => (
  <Box component="a" href={`mailto:${site.contactEmail}`} sx={{ color: tokens.accentStrong }}>
    {site.contactEmail}
  </Box>
);

// About, Privacy and Terms: plain text pages from site.json.
export const ContentPage = ({ page }) => {
  usePageMeta(page);
  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
      <Typography variant="h1" component="h1" sx={{ mb: page.sections ? 1.5 : 3 }}>{page.h1}</Typography>
      {page.sections && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 5 }}>
          Last updated: {page.updated}
        </Typography>
      )}

      {page.paragraphs && page.paragraphs.map((p) => (
        <Typography key={p} sx={{ mb: 2.5, maxWidth: 680, fontSize: '1.0625rem', color: tokens.text }}>{p}</Typography>
      ))}

      {page.sections && page.sections.map((section) => (
        <Box component="section" key={section.heading} sx={{ mb: 4.5, maxWidth: 680 }}>
          <Typography variant="h3" component="h2" sx={{ mb: 1.5 }}>{section.heading}</Typography>
          {section.paragraphs.map((p) => (
            <Typography key={p} color="text.secondary" sx={{ mb: 1.5 }}>{p}</Typography>
          ))}
        </Box>
      ))}

      <Typography sx={{ mt: 4, color: tokens.text }}>
        Contact: <Email />
      </Typography>
    </Container>
  );
};

export const NotFoundPage = () => {
  const page = site.notFound;
  usePageMeta(page);
  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, md: 12 } }}>
      <Typography variant="h1" component="h1" sx={{ mb: 2 }}>{page.h1}</Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>{page.body}</Typography>
      <Button component={RouterLink} to="/" variant="contained">Go to the home page</Button>
    </Container>
  );
};
